import type { CaptureState } from '@Domain/Ports/Capture/CapturePort';

const IN_PROGRESS_STATES: ReadonlyArray<CaptureState> = ['recording', 'paused', 'interrupted'];

/** A capture is in progress while recording, paused or interrupted; `idle` and `stopped` are not. */
const isCaptureInProgress = (state: CaptureState): boolean => {
	return IN_PROGRESS_STATES.includes(state);
};

export default isCaptureInProgress;
